//universal color context
export const themes = [
  {
    name: 'Default',
    tName: 'default',
    value: {
      //main colors
      background: '#0b1826', //darkblue bg, main web page backgrond
      base: '#222a2d', //component background
      primaryShadow: '#1e374f', //dark blue, header, sidebar
      primary: '#325277',
      primaryHighlight: '#436c9a',
      fontColor: '#FFF',
    },
  },
  {
    name: 'Greyscale',
    tName: 'greyscale',
    value: {
      background: '#000000', //darkblue bg, main web page backgrond
      base: '#111111', //component background
      primaryShadow: '#222222', //dark blue, header, sidebar
      primary: '#333333',
      primaryHighlight: '#444444',
      fontColor: '#FFF',
    },
  },
  {
    name: 'High Contrast',
    tName: 'high-contrast',
    value: {
      background: '#000', //darkblue bg, main web page backgrond
      base: '#FFFFFF', //component background
      primaryShadow: '#00FF00', //dark blue, header, sidebar
      primary: '#FFFF00',
      primaryHighlight: '#00FFFF',
      fontColor: '#000',
    },
  },
  {
    name: 'Light Mode',
    tName: 'light',
    value: {
      background: '#f5f5f5', //darkblue bg, main web page backgrond
      base: '#FFFFFF', //component background
      primaryShadow: '#e0e0e0', //dark blue, header, sidebar
      primary: '#d3d3d3',
      primaryHighlight: '#c0c0c0',
      fontColor: '#000',
    },
  },
  {
    name: 'Scarlet',
    tName: 'scarlet',
    value: {
      background: '#07080e',
      base: '#07080e',
      primaryShadow: '#15040b',
      primary: '#350d1d',
      primaryHighlight: '#801530',
      fontColor: '#ff0055',
    },
  },
];
